import React, { useMemo } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import TableContainer from "../../../Components/Common/TableContainer";

const RevenueSummaryTable = ({ summary = {} }) => {

  const revenueData = [
    {
      source: "Room Revenue",
      amount: summary.roomRevenue || 0,
      type: "Room",
    },
    {
      source: "Food Revenue",
      amount: summary.foodRevenue || 0,
      type: "Food",
    },
    {
      source: "Restaurant Revenue",
      amount: summary.restaurantRevenue || 0,
      type: "Restaurant",
    },
    {
      source: "Spa Revenue",
      amount: summary.spaRevenue || 0,
      type: "Spa",
    },
    {
      source: "Tax Collected",
      amount: summary.totalTax || 0,
      type: "Tax",
    },
    {
      source: "Outstanding",
      amount: summary.outstanding || 0,
      type: "Outstanding",
    },
  ];

  const renderBadge = (type) => {
    switch (type) {
      case "Room":
        return (
          <span className="badge bg-primary-subtle text-primary text-uppercase">
            Room
          </span>
        );

      case "Food":
        return (
          <span className="badge bg-success-subtle text-success text-uppercase">
            Food
          </span>
        );

      case "Restaurant":
        return (
          <span className="badge bg-warning-subtle text-warning text-uppercase">
            Restaurant
          </span>
        );

      case "Spa":
        return (
          <span className="badge bg-info-subtle text-info text-uppercase">
            Spa
          </span>
        );

      case "Tax":
        return (
          <span className="badge bg-secondary-subtle text-secondary text-uppercase">
            Tax
          </span>
        );

      case "Outstanding":
        return (
          <span className="badge bg-danger-subtle text-danger text-uppercase">
            Outstanding
          </span>
        );

      default:
        return (
          <span className="badge bg-light text-dark">
            {type}
          </span>
        );
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "Revenue Source",
        accessorKey: "source",
        enableColumnFilter: false,
      },
      {
        header: "Category",
        accessorKey: "type",
        enableColumnFilter: false,
        cell: ({ getValue }) => renderBadge(getValue()),
      },
      {
        header: "Amount",
        accessorKey: "amount",
        enableColumnFilter: false,
        cell: ({ getValue }) =>
          `₹${Number(getValue()).toLocaleString()}`,
      },
    ],
    []
  );

  return (
    <Card className="mt-4">
      <CardHeader>
        <h4 className="card-title mb-0 flex-grow-1">
          Revenue Breakdown
        </h4>
      </CardHeader>

      <CardBody>
        <TableContainer
          columns={columns}
          data={revenueData}
          customPageSize={6}
          className="text-nowrap"
          theadClass="bg-light"
        />
      </CardBody>
    </Card>
  );
};

export default RevenueSummaryTable;